import { Component, Input, OnInit } from '@angular/core';
import { MeteringConceptModel } from '@bo-client/activation-management/shared/models/meteringConceptModel';

@Component({
  selector: 'app-display-concept',
  templateUrl: './display-concept.component.html',
  styleUrls: ['../../../shared/summaries/css-summary.component.scss']
})
export class DisplayConceptComponent implements OnInit {
  @Input() label: string;
  @Input() concept: MeteringConceptModel;

  constructor() {}

  ngOnInit(): void {}
}
